import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/payment-providers')({
  staticData: { breadcrumb: 'Платежи' },
  component: () => <Outlet />,
});
